import { addMedia } from '../api/media'
import { addDocument } from '../api/documents'
import { uploadVoiceNote } from '../api/voice'
import { addNote } from '../api/notes'
import { pendingCaptures, removeCapture, saveCapture, type CaptureRecord } from './offlineStore'

export interface CaptureOutcome { queued: boolean; transcript?: string }

async function send(record: CaptureRecord): Promise<{transcript?:string}> {
  if (record.kind === 'note') {
    await addNote(record.tripId,{client_id:record.id,point_id:record.pointId,text:record.text ?? ''})
    return {}
  }
  if (!record.blob) throw new Error('Capture file is missing')
  if (record.kind === 'voice') {
    const result=await uploadVoiceNote(record.tripId,record.blob,record.pointId,record.id)
    return {transcript:result.transcript}
  }
  const file=new File([record.blob],record.fileName ?? `${record.kind}.bin`,{type:record.blob.type})
  if (record.kind === 'document') await addDocument(record.tripId,{file,point_id:record.pointId,client_id:record.id})
  else await addMedia(record.tripId,{file,point_id:record.pointId,client_id:record.id})
  return {}
}

export async function capture(record: Omit<CaptureRecord,'id'|'createdAt'>): Promise<CaptureOutcome> {
  const saved:CaptureRecord={...record,id:crypto.randomUUID(),createdAt:Date.now()}
  // Persist before sending so a crash or ambiguous server response is retryable.
  await saveCapture(saved)
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return {queued:true}
  try {
    const result=await send(saved)
    await removeCapture(saved.id)
    return {queued:false,...result}
  } catch {
    // The original Blob and stable client ID remain in IndexedDB.
    return {queued:true}
  }
}

export async function drainCaptures(tripId:string):Promise<number> {
  const pending=await pendingCaptures(tripId)
  let sent=0
  for (const record of pending) {
    try { await send(record);await removeCapture(record.id);sent++ }
    catch { break }
  }
  return sent
}
